import { render, staticRenderFns } from "./Product1103001000012ogauc.vue?vue&type=template&id=e080f254"
import script from "./Product1103001000012ogauc.vue?vue&type=script&lang=js"
export * from "./Product1103001000012ogauc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e080f254')) {
      api.createRecord('e080f254', component.options)
    } else {
      api.reload('e080f254', component.options)
    }
    module.hot.accept("./Product1103001000012ogauc.vue?vue&type=template&id=e080f254", function () {
      api.rerender('e080f254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/Product1103001000012ogauc.vue"
export default component.exports